import React from 'react';
import { Helmet } from 'react-helmet';
import AllCategories from '../components/AllCategories';

const CategoriesPage = () => {
  return (
    <>
      <Helmet>
        <title>All Decoration Categories | Habba Events</title>
        <meta 
          name="description" 
          content="Browse our complete collection of premium decoration services. Find the perfect decoration for your birthdays, anniversaries, baby showers, and other special occasions."
        />
      </Helmet>
      
      <AllCategories />
    </>
  );
};

export default CategoriesPage; 